import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useDownloadExport } from './hooks/useDownloadExport';

export const ExportHandler: React.FC<PropsWithChildren> = ({ children }) => {
	useDownloadExport();

	return <>{children}</>;
};
